import React from 'react';
import {Link} from "react-router-dom";

export default class User extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			is_loading: true,
			qs: window.Global.getAllQueryStrings(),
		};
	}

	route() {
		let done = () => {
			window.Route.on({
				'/v2/users/:user_id/bank_book': () => {
					this.setState({
						mode: 'list',
						bank_book: [],
						is_loading: true,
					}, () => {
						this.fetch();
					})
				},
				'/v2/users/:user_id/bank_book/new': () => {
					this.setState({
						mode: 'create',
						bank_book: false,
						is_loading: false,
					}, () => {
						// this.create();
					})
				},
				'/v2/users/:user_id/bank_book/:bank_book_id': (params) => {
					this.setState({
						mode: 'view',
						params: params,
						bank_book: false,
						is_loading: true,
					}, () => {
						this.view();
					})
				},
				'/v2/users/:user_id/bank_book/:bank_book_id/edit': (params) => {
					this.setState({
						mode: 'edit',
						params: params,
						bank_book: false,
						is_loading: true,
					}, () => {
						this.edit();
					})
				},
			}).match();
		}
		if (this.state.user) {
			done();
		} else {
			window.Global.ajax({
				method: 'GET',
				url: process.env.REACT_APP_DOMAIN + '/api/user',
				data: {
					user_id: this.props.match.params.user_id
				},
				done: (response) => {
					this.setState({
						user: response.user[0],
					}, () => {
						done();
					})
				}
			});
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			this.route();
		} else if (this.props.location.search !== prevProps.location.search) {
			// this.setState({
			// 	mode: 'list',
			// 	is_loading: true,
			// }, () => {
			// 	this.fetch();
			// })
		}
	}

	componentDidMount() {
		// if (this.state.mode === 'list') {
		// 	this.fetch();
		// }
		// if (this.state.mode === 'create') {
		// 	this.create();
		// }
		// if (this.state.mode === 'view') {
		// 	this.view();
		// }
		// if (this.state.mode === 'edit') {
		// 	this.edit();
		// }
		this.route();
	}

	setupJqueryThailand() {
		window.$.Thailand({
			database: process.env.REACT_APP_PATH + '/libs/spaceship-web/jquery_Thailand/db.json',
			database_type: 'json',
			autocomplete_size: 20,
			$district: window.$('#district'),
			$amphoe: window.$('#city'),
			$province: window.$('#province'),
			$zipcode: window.$('#zipcode'),
		});
	}

	edit() {
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/v1/bank_book',
			data: {
				bank_book_id: this.state.params.bank_book_id,
				for_user_id: this.state.user.id,
			},
			done: (response) => {
				this.setState({
					is_loading: false,
					bank_book: response.bank_book[0]
				});
			}
		});
	}

	view() {
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/v1/bank_book',
			data: {
				bank_book_id: this.state.params.bank_book_id,
				for_user_id: this.state.user.id,
			},
			done: (response) => {
				this.setState({
					is_loading: false,
					bank_book: response.bank_book[0]
				});
			}
		});
	}

	fetch() {
		let data = {};
		data.for_user_id = this.props.match.params.user_id;
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/v1/bank_book',
			data: data,
			done: (response) => {
				this.setState({
					is_loading: false,
					bank_book: response.bank_book
				}, () => {
					this.$parent.find('.Table_root').tablePagination({
						disableContent: true,
						data: response.bank_book,
						count: response.count,
						onClickPagination: (p) => {
							let qs = window.Global.getAllQueryStrings();
							qs.page = p;
							this.props.history.push(window.Global.getQueryStringLinkFromObject(qs));
						}
					});
				});
			}
		});
	}

	renderView() {
		return (
			<div ref={(ref) => {
				this.$parent = window.$(ref);
				// Route.setLink();
			}} className="main ui container">
				<div style={{marginBottom: '1rem'}}>
					<div className="flex row wrap middle-xs">
						<div className="ui huge breadcrumb">
							<a className="section active"
							   href={process.env.REACT_APP_DOMAIN + "/users"}>
								พนักงาน
							</a>
							{
								this.state.user ?
									<>
										<span className="divider" style={{margin: '0px 1rem'}}>/</span>
										<a className="section"
										   href={process.env.REACT_APP_DOMAIN + "/users/" + this.state.user.id}>
											{this.state.user.name}
										</a>
									</>
									: null
							}
							<span className="divider" style={{margin: '0px 1rem'}}>/</span>
							<Link className="section"
							      to={'/v2/users/' + this.state.qs.id + '/bank_book'}>บัญชีธนาคาร</Link>
							{
								this.state.bank_book ?
									<>
										<span className="divider" style={{margin: '0px 1rem'}}>/</span>
										<div className="section">{this.state.bank_book.name}</div>
									</>
									: null
							}
						</div>
					</div>
					<UserMenu user_id={this.state.user.id} index={1}/>
				</div>
				<div
					className={this.state.is_loading ? "ui tall stacked loading segment" : "ui tall stacked segment"}>
					<form className="ui form" autoComplete="off">
						<div className="flex row wrap middle-xs Signature_head" style={{padding: '2px 0 14px 0'}}>
							<h2 style={{margin: 0}}>
								บัญชีธนาคาร
							</h2>
							<div className="flex row right floated">
								<button type={"button"}
								        className={"ui button basic"}
								        onClick={() => {
									        this.void()
								        }}>ลบ
								</button>
								<div className="ui basic gray buttons">
									<Link className={"ui button basic"}
									      to={"/v2/users/" + this.state.user.id + '/bank_book/' + this.state.bank_book.id + '/edit'}
									>
										แก้ไขบัญชีธนาคาร
									</Link>
								</div>
							</div>
						</div>
						<div className="ui divider" style={{margin: '0 0 14px'}}/>
						<div className="flex row wrap padded four column computer">
							<div className="column field">
								<div className="flex row wrap middle-xs">
									<img src={this.state.bank_book.logo_url}
									     alt="logo"
									     className="ui image tiny circular"
									/>&nbsp;&nbsp;&nbsp;
									<div>
										<b>{this.state.bank_book.code_name}</b>
										<br/><b>{this.state.bank_book.no}</b>
										<br/><b>{this.state.bank_book.name}</b>
										<br/><b>{this.state.bank_book.type}</b>
									</div>
								</div>
							</div>
							<div className="column field">
								<label>ชื่อสาขา</label>
								<p>{this.state.bank_book.branch_name}</p>
							</div>
							<div className="column field">
								<label>ตั้งเป็นบัญชีธนาคารหลัก</label>
								<p>
									{this.state.bank_book.bank_book_own_user.is_default ?
										<i className="icon check green"/>
										: <i className="icon times" style={{color: 'red'}}/>
									}
								</p>
							</div>
						</div>
					</form>
				</div>
			</div>
		);
	}

	renderList() {
		return (
			<div ref={(ref) => {
				if (!ref) return;
				this.$parent = window.$(ref);
			}}
			     key={'ddd' + window.Global.getRandomInt(1, 99999999)}
			     className="main ui container">
				<div style={{marginBottom: '1rem'}}>
					<div className="flex row wrap middle-xs">
						<div className="ui huge breadcrumb">
							<a className="section active"
							   href={process.env.REACT_APP_DOMAIN + "/users"}>
								พนักงาน
							</a>
							{
								this.state.user ?
									<>
										<span className="divider" style={{margin: '0px 1rem'}}>/</span>
										<a className="section"
										   href={process.env.REACT_APP_DOMAIN + "/users/" + this.state.user.id}>
											{this.state.user.name}
										</a>
									</>
									: null
							}
							<span className="divider" style={{margin: '0px 1rem'}}>/</span>
							<div className="section">บัญชีธนาคาร</div>
						</div>

						<div className="right floated">
							<Link id="addSaleOrderButton" to={"/v2/users/" + this.state.user.id + "/bank_book/new"}
							      className="ui positive button">เพิ่มบัญชีธนาคาร</Link>
						</div>
					</div>
					<UserMenu user_id={this.state.user.id} index={1}/>
				</div>
				<div className="flex row wrap padded">
					<div className="col-xs-16 padded">
						<div className="ui basic table can click Table_root td-top-xs" style={{marginTop: 0}}>
							<div className="thead">
								<div className="tr">
									<div className="th span10">ธนาคาร</div>
									<div className="th span3">เลขที่สาขา</div>
									<div className="th span3">ตั้งเป็นบัญชีธนาคารหลัก</div>
								</div>
							</div>
							<div className="tbody">
								{
									this.state.is_loading
										? <div className="tr">
											<div className="td center aligned" data-info="nodata">
												<div className="ui active centered inline small loader"/>
											</div>
										</div>
										: null
								}
								{
									this.state.bank_book.length === 0
									&& !this.state.is_loading
									&& (
										!window.Global.getAllQueryStrings().page
										|| window.Global.getAllQueryStrings().page === '1'
									)
										? <div className="tr">
											<div className="td span16" style={{textAlign: 'center'}}>ไม่พบข้อมูล</div>
										</div>
										: null
								}
								{
									this.state.bank_book
									&& this.state.bank_book.length > 0 ?
										this.state.bank_book.map((bank_book, bank_book_index) => {
											return (
												<Link className="tr"
												      to={"/v2/users/" + this.state.user.id + "/bank_book/" + bank_book.id}
												      key={bank_book_index}>
													<div className="td span10">
														<div className="flex row wrap middle-xs">
															<img src={bank_book.logo_url}
															     alt="logo"
															     className="ui image tiny circular"
															/>&nbsp;&nbsp;&nbsp;
															<div>
																<b>{bank_book.code_name}</b>
																<br/><b>{bank_book.no}</b>
																<br/><b>{bank_book.name}</b>
																<br/><b>{bank_book.type}</b>
															</div>
														</div>
													</div>
													<div className="td span3">
														<div>{bank_book.branch_name}</div>
													</div>
													<div className="td span3">
														<p>
															{
																bank_book.bank_book_own_user.is_default
																	? <i className="icon check green"/>
																	: <i className="icon times" style={{color: 'red'}}/>
															}
														</p>
													</div>
												</Link>
											)
										})
										: null
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	render() {
		if (this.state.is_loading) {
			return null;
		}

		if (this.state.mode === 'list') {
			return this.renderList();
		}

		if (this.state.mode === 'view') {
			return this.renderView();
		}

		if (this.state.mode === 'edit' && !this.state.bank_book) return (<div/>);

		return (
			<div ref={(ref) => {
				this.$parent = window.$(ref);
				this.$parent.find('form').form2('setup');
				this.$parent.find('form').form2('submit', {
					method: this.state.mode === 'create'
						? 'POST'
						: 'PUT',
					url: process.env.REACT_APP_DOMAIN + '/api/v1/bank_book',
					beforeSent: (object) => {
						return object;
					},
					loadingButton: window.$(this.$parent).find('#submit-button'),
					onSuccess: (response) => {
						// console.log(response);
						window.Global.messageTop({
							type: 'positive',
							message: 'บันทึกข้อมูลสำเร็จ'
						});
						this.props.history.push({
							pathname: '/v2/users/' + this.state.user.id + '/bank_book/' + response.bank_book.id,
							// search: "?id=" + this.state.qs.id,
							state: null
						});
					}
				});
			}} className="main ui container">
				<div style={{marginBottom: '1rem'}}>
					<div className="flex row wrap middle-xs">
						<div className="ui huge breadcrumb">
							<a className="section active"
							   href={process.env.REACT_APP_DOMAIN + "/users"}>
								พนักงาน
							</a>
							{
								this.state.user ?
									<>
										<span className="divider" style={{margin: '0px 1rem'}}>/</span>
										<a className="section"
										   href={process.env.REACT_APP_DOMAIN + "/users/" + this.state.user.id}>
											{this.state.user.name}
										</a>
									</>
									: null
							}
							<span className="divider" style={{margin: '0px 1rem'}}>/</span>
							<Link className="section"
							      to={'/v2/users/' + this.state.user.id + '/bank_book'}>บัญชีธนาคาร</Link>
							<span className="divider" style={{margin: '0px 1rem'}}>/</span>
							<div className="section">{this.state.mode === "create" ? "เพิ่ม" : "แก้ไข"}</div>
						</div>
					</div>
					<UserMenu user_id={this.state.user.id} index={1}/>
				</div>
				<form
					className={this.state.is_loading ? "ui form ui tall stacked loading segment" : "ui form ui tall stacked segment"}
					autoComplete="off">
					<div className="flex row wrap middle-xs Signature_head" style={{padding: '2px 0 14px 0'}}>
						<h2 style={{margin: 0}}>
							{this.state.mode === 'edit' ? 'แก้ไข' : null}
							บัญชีธนาคาร
							{this.state.mode === 'create' ? 'ใหม่' : null}
						</h2>
					</div>
					<div className="ui divider" style={{margin: '0 0 14px 0'}}/>
					<div className={"flex row wrap padded two column computer"}>
						<div className="column field required">
							<label>ธนาคาร</label>
							<select name="code"
							        className="ui dropdown search"
							        data-form2_setup=""
							        ref={(e) => {
								        window.$(e).html(window.Bank.getOptionList());
								        window.$(e).find('*:first-child').remove();
								        if (this.state.mode === 'edit') {
									        window.$(e).find('*[value=' + this.state.bank_book.code + ']')
										        .attr('selected', 'selected');
								        }
							        }}
							/>
						</div>
						<div className="column field required">
							<label>เลขที่บัญชี</label>
							<input type="text"
							       name="no"
							       defaultValue={
								       this.state.mode === 'create'
									       ? ''
									       : this.state.bank_book.no
							       }
							/>
						</div>
						<div className="column field required">
							<label>ชื่อบัญชี</label>
							<input type="text"
							       name="name"
							       defaultValue={
								       this.state.mode === 'create'
									       ? ''
									       : this.state.bank_book.name
							       }
							/>
						</div>
						<div className="column field">
							<label>ชื่อสาขา</label>
							<input type="text"
							       name="branch_name"
							       defaultValue={
								       this.state.mode === 'create'
									       ? ''
									       : this.state.bank_book.branch_name
							       }
							/>
						</div>
						<div className="column field required">
							<label>ประเภทบัญชี</label>
							<select name="type"
							        className="ui dropdown"
							        defaultValue={
								        this.state.mode === 'create'
									        ? 'ออมทรัพย์'
									        : this.state.bank_book.type
							        }
							        data-form2_setup="">
								<option value="ออมทรัพย์">ออมทรัพย์</option>
								<option value="กระแสรายวัน">กระแสรายวัน</option>
							</select>
						</div>
						<div className="column field">
							<label>&nbsp;</label>
							<div className="ui checkbox" data-form2_setup="">
								<input id="is_default"
								       type="checkbox"
								       tabIndex="0"
								       className="hidden"
								       defaultChecked={
									       this.state.mode === 'create'
										       ? true
										       : this.state.bank_book.bank_book_own_user.is_default === 1
								       }
								       name="is_default"/>
								<label htmlFor="is_default"><b>ตั้งเป็นบัญชีธนาคารหลัก</b></label>
							</div>
						</div>
					</div>
					<div className="ui error message"/>
					<br/>
					<br/>
					<div className="flex row">
						<div className="right floated">
							{
								this.state.user
								&& this.state.user.id
									?
									<input type={"hidden"} name={"user_id"}
									       defaultValue={this.state.user.id}/>
									: null
							}
							{
								this.state.bank_book
								&& this.state.bank_book.id
									?
									<input type={"hidden"}
									       name={"bank_book_id"}
									       defaultValue={this.state.bank_book.id}/>
									: null
							}
							<Link
								to={
									this.state.mode === 'create'
										? '/v2/users/' + this.state.user.id + '/bank_book'
										: '/v2/users/' + this.state.user.id + '/bank_book/' + this.state.bank_book.id
								}
								className={"ui button"}>ยกเลิก</Link>
							<button id="submitButton" className="ui positive button" type="submit">
								{this.state.mode === 'create' ? 'เพิ่มบัญชีธนาคาร' : null}
								{this.state.mode === 'edit' ? 'บันทึก' : null}
							</button>
						</div>
					</div>
				</form>
			</div>
		);
	}


	void() {
		window.Global.confirm({
			title: 'ยืนยันลบข้อมูล',
			content: '<form class="ui form">\n\t<p>โปรดยืนยันลบข้อมูล การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้</p>\n\t<div class="ui error message"></div>\n</form>',
			cancel_text: 'ยกเลิก',
			approve_text: 'ลบข้อมูล',
			onShowToSetupForm: ($modal) => {
				$modal.find('form').form2('setup');
				$modal.find('form').form2('submit', {
					method: 'DELETE',
					url: process.env.REACT_APP_DOMAIN + '/api/v1/bank_book',
					loadingButton: $modal.find('.button.approve'),
					beforeSent: (data) => {
						data.bank_book_id = this.state.bank_book.id;
						return data;
					},
					onSuccess: () => {
						$modal.modal('hide');
						window.Global.messageTop({
							type: 'positive',
							message: 'ลบข้อมูลสำเร็จ'
						});
						this.props.history.push({
							pathname: '/v2/users/' + this.state.user.id + 'bank_book',
							//search: "?id=" + this.state.qs.id,
							state: null
						});
					}
				});
			}
		});
	}
}

export class UserMenu extends React.Component {
	render() {
		return (
			<div className="ui menu flex row wrap Setting_menu">
				<a className={this.props.index === 0 ? "item active" : "item"}
				   href={process.env.REACT_APP_DOMAIN + "/users/" + this.props.user_id}>ข้อมูลพนักงาน</a>
				<Link className={this.props.index === 1 ? "item active" : "item"}
				      to={"/v2/users/" + this.props.user_id + "/bank_book"}>บัญชีธนาคาร</Link>
				<a className={this.props.index === 2 ? "item active" : "item"}
				   href={process.env.REACT_APP_DOMAIN + "/users/" + this.props.user_id + "?page=permission"}>สิทธิ์การใช้งาน</a>
				{/*<a className={this.props.index === 0 ? "item active" : "item"}*/}
				{/*   href={process.env.REACT_APP_DOMAIN + "/users/" + this.props.user_id + "/task"}>ปฏิทินงาน</a>*/}
				{/*<a className={this.props.index === 0 ? "item active" : "item"}*/}
				{/*   href={process.env.REACT_APP_DOMAIN + "/users/" + this.props.user_id + "/working-range"}>กำหนดวันทำงาน</a>*/}
				{/*<a className={this.props.index === 0 ? "item active" : "item"}*/}
				{/*   href={process.env.REACT_APP_DOMAIN + "/users/" + this.props.user_id + "/leave-remain-adjustment"}>เปลี่ยนแปลงจำนวนวันลา</a>*/}
			</div>
		);
	}
}
